import(/* webpackMode: "eager" */ "/codebuild/output/src509251388/src/skop-manage/src/app/[locale]/error.tsx");
